import React from 'react'
import './Home.scss'
import Navbar from '../../Components/Navbar/Navbar'
import Landing from '../../Components/Landing/Landing'
import Features from '../../Components/Features/Features'
import Pricing from '../../Components/Pricing/Pricing'
import Faq from '../../Components/Faq/Faq'

function Home() {
  return (
    <div>
      <div className='landingBackground'>
        <Navbar 
        homeNav='navbar navbar-expand-md navbar-dark bg-custom'
        dashButton='Dashboard'
        link="/dashboard"
        />
        <Landing/>
      </div>
      <Features/>
      <Pricing/>
      <Faq/>
    </div>
  )
}

export default Home